"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AuInputProps = exports.AuDayPickerInputProps = exports.AssetProps = void 0;
exports.wShape = wShape;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var T = _interopRequireWildcard(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function arrayDiff(a, b) {
  return (0, _filter.default)(a).call(a, x => (0, _indexOf.default)(b).call(b, x) < 0);
}
function wShape(shape) {
  // Whitelist shape - throws if any shape's keys are not in the whitelist
  return (props, propName, component, ...rest) => {
    if (props[propName] != null) {
      const whitelist = (0, _keys.default)(shape);
      const propKeys = (0, _keys.default)(props[propName]);
      const extra = arrayDiff(propKeys, whitelist);
      if (extra.length) {
        return new Error("unexpected keys for " + propName + ": " + extra + ' in ' + component + ' ' + rest[1]);
      }
    }
    return T.shape(shape)(props, propName, component, ...rest);
  };
}
const AssetProps = {
  vehicle_id: T.string,
  fleet: T.shape({
    id: T.string,
    name: T.string
  }),
  make: T.string,
  model: T.string,
  status: T.string,
  pid_plugged_in: T.string,
  // odometer: T.number,
  location: T.shape({
    lat: T.number,
    lon: T.number,
    time: T.string
  })
};
exports.AssetProps = AssetProps;
const AuInputProps = {
  type: T.string,
  name: T.string,
  value: T.any,
  defaultValue: T.any,
  className: T.string,
  maxLength: T.string,
  placeholder: T.string,
  placeholderId: T.string,
  autoComplete: T.string,
  autoFocus: T.bool,
  readOnly: T.bool,
  modified: T.bool,
  createMode: T.bool,
  showError: T.bool,
  showClear: T.bool,
  error: T.object,
  checked: T.bool,
  disabled: T.bool,
  onMount: T.func,
  onClick: T.func,
  onChange: T.func,
  onClear: T.func,
  onFocus: T.func,
  onBlur: T.func,
  onKeyDown: T.func,
  onKeyUp: T.func,
  tabIndex: T.number,
  min: T.number,
  max: T.number
};
exports.AuInputProps = AuInputProps;
const AuDayPickerInputProps = {
  value: T.oneOfType([T.string, T.instanceOf(Date)]),
  format: T.oneOfType([T.string, T.arrayOf(T.String)]),
  inputProps: T.shape(AuInputProps),
  dayPickerProps: T.shape(),
  className: T.string,
  overlayClassName: T.string,
  overlayWrapperClassName: T.string,
  overlayComponent: T.any,
  showOverlay: T.bool,
  hideOnDayClick: T.bool,
  createMode: T.bool,
  onMonthChange: T.func,
  onDayChange: T.func,
  onChange: T.func,
  onKeyUp: T.func,
  onClick: T.func,
  onFocus: T.func,
  onBlur: T.func
};
exports.AuDayPickerInputProps = AuDayPickerInputProps;